import { ModalStatic } from '@app/base/service/modal.static';

export class ExpiredPermissionUiStatic {
    static open() {
        ModalStatic.open('expiredPermission');
    }

    static close() {
        ModalStatic.close('expiredPermission');
    }
}